module.exports = __webpack_public_path__ + "static/img/11bg_3.6f34d3d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/11bg_3.png
// module id = 622
// module chunks = 1